export default __webpack_public_path__ + "static/media/Gradient_Bg.e1555bd0.svg";